function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Transaction = require('../../../lib/saito/transaction')["default"];
var _require = require('./document'),
  copy = _require.copy,
  ACTION_TYPES = _require.ACTION_TYPES;
var _require2 = require('./auth'),
  documentHash = _require2.documentHash,
  verifyFinalization = _require2.verifyFinalization,
  verifyCreatorProof = _require2.verifyCreatorProof;
var MODULE = 'SaitoSign';
var REQUEST = 'saitosign document';
function looksLikeWebTransaction(text) {
  try {
    var json = JSON.parse(String(text || '').trim());
    return Boolean(json && typeof json.t === 'string' && json.m !== undefined);
  } catch (err) {
    return false;
  }
}
function flag(value) {
  return value === true;
}
function readShareMetadata(value) {
  var tier = (value === null || value === void 0 ? void 0 : value.tier) === 'premium' ? 'premium' : 'free';
  var tierOwner = String((value === null || value === void 0 ? void 0 : value.tier_owner) || '').trim();
  var verification = (value === null || value === void 0 ? void 0 : value.verification) || {};
  var selectedVerification = {
    email: verification.email !== false,
    phone: tier === 'premium' && flag(verification.phone),
    photo: flag(verification.photo),
    passport: flag(verification.passport),
    legal_review: tier === 'premium' && flag(verification.legal_review)
  };
  if (tier !== 'premium') {
    return {
      tier: 'free',
      tier_owner: tierOwner,
      verification: selectedVerification
    };
  }
  return {
    tier: 'premium',
    tier_owner: tierOwner,
    verification: selectedVerification,
    online_signing: flag(value === null || value === void 0 ? void 0 : value.online_signing),
    archive_contract: flag(value === null || value === void 0 ? void 0 : value.archive_contract)
  };
}
function shareMetadata(plan, options) {
  var tierOwner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var selected = options || {};
  var owner = String(tierOwner || '').trim();
  var premium = plan === 'premium';
  var metadata = {
    tier: premium ? 'premium' : 'free',
    tier_owner: owner,
    verification: {
      email: flag(selected.email),
      phone: premium && flag(selected.phone),
      photo: flag(selected.photo),
      passport: flag(selected.passport),
      legal_review: premium && flag(selected.legal_review)
    }
  };
  if (!premium) return metadata;
  return _objectSpread(_objectSpread({}, metadata), {}, {
    online_signing: flag(selected.online_signing),
    archive_contract: flag(selected.archive_contract)
  });
}
function createPrepareTransaction(_x, _x2) {
  return _createPrepareTransaction.apply(this, arguments);
}
function _createPrepareTransaction() {
  _createPrepareTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, record) {
    var tx, data, stored;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(record !== null && record !== void 0 && record.creator && !verifyCreatorProof(app, record))) {
            _context.n = 1;
            break;
          }
          throw new Error('The creator identity for this document could not be verified.');
        case 1:
          if (!(record !== null && record !== void 0 && record.finalized && !verifyFinalization(app, record))) {
            _context.n = 2;
            break;
          }
          throw new Error('The creator signature for this finalized document is invalid.');
        case 2:
          tx = new Transaction();
          data = copy(record);
          stored = String(data.hash || '').trim();
          delete data.hash;
          if (record !== null && record !== void 0 && record.metadata) {
            data.metadata = readShareMetadata(record.metadata);
          }
          if (!(record !== null && record !== void 0 && record.finalized && (!stored || stored !== documentHash(app, data)))) {
            _context.n = 3;
            break;
          }
          throw new Error('This document no longer matches its finalized Document Hash.');
        case 3:
          tx.timestamp = Date.now();
          tx.msg = {
            module: MODULE,
            request: REQUEST,
            data: data
          };
          if (record !== null && record !== void 0 && record.finalized) {
            tx.msg['Document Hash'] = stored;
          }
          return _context.a(2, tx);
      }
    }, _callee);
  }));
  return _createPrepareTransaction.apply(this, arguments);
}
function readPrepareTransaction(app, text) {
  var _data$finalization;
  var raw = String(text || '').trim();
  if (!looksLikeWebTransaction(raw)) {
    throw new Error('That file is not a SaitoSign transaction.');
  }
  var tx = new Transaction();
  tx.deserialize_from_web(app, raw);
  var data = prepareData(tx);
  if (!data) {
    throw new Error('That file is not a SaitoSign transaction.');
  }
  if ((data.finalized || (_data$finalization = data.finalization) !== null && _data$finalization !== void 0 && _data$finalization.signature) && !verifyFinalization(app, data)) {
    throw new Error('The creator signature for this finalized document is invalid.');
  }
  if (data.creator && !verifyCreatorProof(app, data)) {
    throw new Error('The creator identity for this document could not be verified.');
  }
  return data;
}
function prepareData(tx) {
  var msg = typeof (tx === null || tx === void 0 ? void 0 : tx.returnMessage) === 'function' ? tx.returnMessage() : tx === null || tx === void 0 ? void 0 : tx.msg;
  if (!msg || msg.module !== MODULE || msg.request !== REQUEST || !msg.data) {
    return null;
  }
  var data = msg.data;
  var record = data.document && Array.isArray(data.document.pdf) && Array.isArray(data.actions) ? readRecord(data) : null;
  if (!record) {
    return null;
  }
  var named = String(msg['Document Hash'] || '').trim();
  var embedded = String(record.hash || '').trim();
  if (named && embedded && named !== embedded) {
    return null;
  }
  record.hash = named || embedded;
  return record;
}
function readPdfEntry(entry) {
  var name = String((entry === null || entry === void 0 ? void 0 : entry.name) || 'document.pdf').trim();
  var pdf = String((entry === null || entry === void 0 ? void 0 : entry.pdf) || '');
  if (!name || !pdf) {
    return null;
  }
  return {
    name: name,
    pdf: pdf,
    page_count: Number(entry === null || entry === void 0 ? void 0 : entry.page_count) || 0,
    page_width: Number(entry === null || entry === void 0 ? void 0 : entry.page_width) || 0,
    page_height: Number(entry === null || entry === void 0 ? void 0 : entry.page_height) || 0
  };
}
function readRecord(data) {
  var pdf = [];
  var _iterator = _createForOfIteratorHelper(data.document.pdf),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;
      var next = readPdfEntry(entry);
      if (!next) {
        return null;
      }
      pdf.push(next);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!pdf.length) {
    return null;
  }
  var name = String(data.document.name || pdf[0].name || 'document.pdf').trim();
  if (!name) {
    return null;
  }
  var users = readUsers(data.users);
  if (!users) {
    return null;
  }
  var actions = readActions(data.actions, users.length);
  if (!actions) {
    return null;
  }
  var page_count = Number(data.document.page_count) || pdf.reduce(function (total, entry) {
    return total + entry.page_count;
  }, 0);
  var record = {
    hash: String(data.hash || ''),
    creator: String(data.creator || ''),
    creatorProof: data.creatorProof && _typeof(data.creatorProof) === 'object' ? JSON.parse(JSON.stringify(data.creatorProof)) : null,
    finalized: data.finalized === true,
    finalization: data.finalization && _typeof(data.finalization) === 'object' ? JSON.parse(JSON.stringify(data.finalization)) : null,
    document: {
      name: name,
      pdf: pdf,
      page_count: page_count,
      page_width: Number(data.document.page_width) || pdf[0].page_width || 0,
      page_height: Number(data.document.page_height) || pdf[0].page_height || 0
    },
    users: users,
    actions: actions
  };
  if (data.metadata && _typeof(data.metadata) === 'object') {
    record.metadata = readShareMetadata(data.metadata);
  }
  return record;
}
function readLegacy(data) {
  if (typeof (data === null || data === void 0 ? void 0 : data.name) !== 'string' || !data.name.trim() || typeof data.pdf !== 'string' || !data.pdf) {
    return null;
  }
  if (!Array.isArray(data.signers) || !data.signers.every(function (name) {
    return typeof name === 'string' && name.trim();
  })) {
    return null;
  }
  var users = data.signers.map(function (name, index) {
    var stored = Array.isArray(data.users) ? data.users[index] : null;
    return {
      name: name.trim(),
      email: String((stored === null || stored === void 0 ? void 0 : stored.email) || '').trim(),
      publickey: String((stored === null || stored === void 0 ? void 0 : stored.publickey) || (stored === null || stored === void 0 ? void 0 : stored.publicKey) || ''),
      verifications: readVerifications(stored === null || stored === void 0 ? void 0 : stored.verifications),
      signatures: readSignatures(stored === null || stored === void 0 ? void 0 : stored.signatures)
    };
  });
  var actions = [];
  if (!Array.isArray(data.fields)) {
    return null;
  }
  data.fields.forEach(function (field, index) {
    var placed = readPlacement(field, users.length);
    if (!placed) {
      actions.push(null);
      return;
    }
    actions.push(_objectSpread({
      id: index + 1
    }, placed));
  });
  if (actions.some(function (action) {
    return !action;
  }) || !users.length && actions.length) {
    return null;
  }
  var record = {
    hash: String(data.hash || ''),
    creator: String(data.creator || ''),
    creatorProof: data.creatorProof && _typeof(data.creatorProof) === 'object' ? JSON.parse(JSON.stringify(data.creatorProof)) : null,
    finalized: data.finalized === true,
    finalization: data.finalization && _typeof(data.finalization) === 'object' ? JSON.parse(JSON.stringify(data.finalization)) : null,
    document: {
      name: data.name.trim(),
      pdf: data.pdf,
      page_count: 0,
      page_width: 0,
      page_height: 0
    },
    users: users,
    actions: actions
  };
  if (data.metadata && _typeof(data.metadata) === 'object') {
    record.metadata = readShareMetadata(data.metadata);
  }
  return record;
}
function readUsers(list) {
  if (!Array.isArray(list)) {
    return null;
  }
  var users = [];
  var _iterator2 = _createForOfIteratorHelper(list),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var user = _step2.value;
      var name = String((user === null || user === void 0 ? void 0 : user.name) || '').trim();
      if (!name) {
        return null;
      }
      users.push({
        name: name,
        email: String((user === null || user === void 0 ? void 0 : user.email) || '').trim(),
        publickey: String((user === null || user === void 0 ? void 0 : user.publickey) || ''),
        verifications: readVerifications(user === null || user === void 0 ? void 0 : user.verifications),
        signatures: readSignatures(user === null || user === void 0 ? void 0 : user.signatures)
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return users;
}
function readSignatures(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  var signatures = [];
  var _iterator3 = _createForOfIteratorHelper(list),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var entry = _step3.value;
      var id = Number(entry === null || entry === void 0 ? void 0 : entry.id);
      var signature = String((entry === null || entry === void 0 ? void 0 : entry.signature) || '');
      var documentHashValue = String((entry === null || entry === void 0 ? void 0 : entry.document_hash) || '').trim();
      if (!Number.isInteger(id) || id < 1 || !signature) {
        continue;
      }
      var next = {
        id: id,
        signature: signature
      };
      if (documentHashValue) {
        next.document_hash = documentHashValue;
      }
      signatures.push(next);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return signatures;
}
function readVerifications(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map(function (entry) {
    var next = {
      method: String((entry === null || entry === void 0 ? void 0 : entry.method) || ''),
      publickey: String((entry === null || entry === void 0 ? void 0 : entry.publickey) || ''),
      message: String((entry === null || entry === void 0 ? void 0 : entry.message) || ''),
      signature: String((entry === null || entry === void 0 ? void 0 : entry.signature) || '')
    };
    var photo = typeof (entry === null || entry === void 0 ? void 0 : entry.photo) === 'string' ? entry.photo : '';
    if (photo) {
      next.photo = photo;
    }
    var image = typeof (entry === null || entry === void 0 ? void 0 : entry.image) === 'string' ? entry.image : '';
    if (image) {
      next.image = image;
    }
    return next;
  });
}
function readActions(list, userCount) {
  if (!Array.isArray(list)) {
    return null;
  }
  var actions = [];
  var _iterator4 = _createForOfIteratorHelper(list),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var action = _step4.value;
      var placed = readPlacement(action, userCount);
      var id = Number(action === null || action === void 0 ? void 0 : action.id);
      if (!placed || !Number.isInteger(id) || id < 1) {
        return null;
      }
      actions.push(_objectSpread({
        id: id
      }, placed));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  if (!userCount && actions.length) {
    return null;
  }
  return actions;
}
function readPlacement(action, userCount) {
  var type = action === null || action === void 0 ? void 0 : action.type;
  if (!ACTION_TYPES[type]) {
    return null;
  }
  var user = Number(action.user !== undefined ? action.user : action.signer);
  if (!Number.isInteger(user) || user < 0 || user >= userCount) {
    return null;
  }
  var page = Number(action.page);
  var x = fraction(action.x);
  var y = fraction(action.y);
  var width = fraction(action.width);
  var height = fraction(action.height);
  if (!Number.isInteger(page) || page < 1 || x === null || y === null || width === null || height === null) {
    return null;
  }
  if (width <= 0 || height <= 0) {
    return null;
  }
  var next = {
    type: type,
    user: user,
    page: page,
    x: x,
    y: y,
    width: width,
    height: height
  };
  var group = String((action === null || action === void 0 ? void 0 : action.group) || '').trim();
  if (group) {
    next.group = group;
  }
  return next;
}
function downloadBlob(blob, filename) {
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
function downloadTransaction(app, tx, filename) {
  var json = tx.serialize_to_web(app);
  downloadBlob(new Blob([json], {
    type: 'application/json'
  }), filename);
}
function downloadBytes(bytes, filename) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/octet-stream';
  downloadBlob(new Blob([bytes], {
    type: type
  }), filename);
}
function fraction(value) {
  var number = Number(value);
  if (!Number.isFinite(number) || number < 0 || number > 1) {
    return null;
  }
  return number;
}
module.exports = {
  MODULE: MODULE,
  REQUEST: REQUEST,
  looksLikeWebTransaction: looksLikeWebTransaction,
  createPrepareTransaction: createPrepareTransaction,
  readPrepareTransaction: readPrepareTransaction,
  downloadTransaction: downloadTransaction,
  downloadBytes: downloadBytes,
  shareMetadata: shareMetadata,
  readShareMetadata: readShareMetadata
};